import {
  Container,
  Header,
  Box,
  SpaceBetween,
  FormField,
  Textarea,
} from "@cloudscape-design/components-themed";
import {
  LABELS,
  REQUEST_AFTER_FOR_REQUESTER,
  REQUEST_AFTER_FOR_APPROVER,
  APPROVAL_AFTER,
  SEND_BACK,
  NEW_OR_PULLBACK,
  COMMENT_MAX_LENGTH,
} from "./constants";
import { Dispatch, SetStateAction, useState } from "react";
import { isLengthValid } from "../../utils/inputValidation";
import { getMessage } from "../../features/error/messages";

interface IExaminationComment {
  currentStage: number;
  examinationCommentDocomo: string;
  examinationDecisionCode: string;
  examinationCommentVmtf: string;
  examinationCommentVmsmcc: string;
  examinationCommentVmsaison: string;
  examinationCommentJcb: string;
  examinationCommentAmex: string;
  examinationComment: string;
  setExaminationComment: Dispatch<SetStateAction<string>>;
  actionComment: string;
}

/**
 * 審査コメント/登録
 */
const ExaminationComment = (props: IExaminationComment) => {
  const {
    currentStage,
    examinationCommentDocomo,
    examinationDecisionCode,
    examinationCommentVmtf,
    examinationCommentVmsmcc,
    examinationCommentVmsaison,
    examinationCommentJcb,
    examinationCommentAmex,
    examinationComment,
    setExaminationComment,
    actionComment,
  } = props;
  const headerTitle = [NEW_OR_PULLBACK, SEND_BACK].includes(currentStage)
    ? LABELS.EXAMINATION_COMMENT_REGISTRATION
    : LABELS.EXAMINATION_COMMENT;
  const [examinationCommentErrorMsg, setExaminationCommentErrorMsg] =
    useState("");

  /**
   * 審査コメントの入力ハンドラ.
   * @param {string} inputComment
   */
  const examinationCommentOnChange = (inputComment: string) => {
    setExaminationComment(inputComment);
    const errorMsg = isLengthValid(inputComment, COMMENT_MAX_LENGTH)
      ? ""
      : getMessage("KGRERR058", 500).label;
    setExaminationCommentErrorMsg(errorMsg);
  };

  return (
    <Container header={<Header variant={"h2"}>{headerTitle}</Header>}>
      <Box margin={"s"}>
        <SpaceBetween direction={"vertical"} size={"l"}>
          <SpaceBetween direction={"vertical"} size={"xs"}>
            <FormField label={LABELS.EXAMINATION_COMMENT_DOCOMO}>
              <Textarea value={examinationCommentDocomo} rows={2} readOnly />
            </FormField>
            <FormField label={LABELS.EXAMINATION_JUDGEMENT_CODE_DOCOMO}>
              <Textarea value={examinationDecisionCode} rows={4} readOnly />
            </FormField>
            <FormField label={LABELS.EXAMINATION_COMMENT_VM_SMCC}>
              <Textarea value={examinationCommentVmsmcc} rows={2} readOnly />
            </FormField>
            <FormField label={LABELS.EXAMINATION_COMMENT_VM_TF}>
              <Textarea value={examinationCommentVmtf} rows={2} readOnly />
            </FormField>
            <FormField label={LABELS.EXAMINATION_COMMENT_VM_SAISON}>
              <Textarea value={examinationCommentVmsaison} rows={2} readOnly />
            </FormField>
            <FormField label={LABELS.EXAMINATION_COMMENT_JCB}>
              <Textarea value={examinationCommentJcb} rows={2} readOnly />
            </FormField>
            <FormField label={LABELS.EXAMINATION_COMMENT_AMEX}>
              <Textarea value={examinationCommentAmex} rows={2} readOnly />
            </FormField>
          </SpaceBetween>
          <FormField
            label={LABELS.EXAMINATION_COMMENT}
            constraintText={
              currentStage === NEW_OR_PULLBACK
                ? `${COMMENT_MAX_LENGTH}文字以内`
                : ""
            }
            errorText={examinationCommentErrorMsg}
          >
            <Textarea
              value={examinationComment}
              onChange={({ detail }) =>
                examinationCommentOnChange(detail.value)
              }
              rows={2}
              readOnly={[
                REQUEST_AFTER_FOR_REQUESTER,
                REQUEST_AFTER_FOR_APPROVER,
                APPROVAL_AFTER,
              ].includes(currentStage)}
            />
          </FormField>
          {currentStage === SEND_BACK && (
            <FormField label={LABELS.SEND_BACK_COMMENT}>
              <Textarea value={actionComment} rows={2} readOnly />
            </FormField>
          )}
        </SpaceBetween>
      </Box>
    </Container>
  );
};

export default ExaminationComment;
